import { render, staticRenderFns } from "./resetUserDialog.vue?vue&type=template&id=6272d69d&scoped=true&"
import script from "./resetUserDialog.vue?vue&type=script&lang=js&"
export * from "./resetUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./resetUserDialog.vue?vue&type=style&index=0&id=6272d69d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6272d69d",
  null
  
)

export default component.exports